export class TokenStore {
  private ACCESS = 'access';
  private REFRESH = 'refresh';
  private HACK = 'hack';

  getAccess(): string | null {
    return localStorage.getItem(this.ACCESS);
  }
  getRefresh(): string | null {
    return localStorage.getItem(this.REFRESH);
  }

  setTokens(access: string, refresh: string): void {
    localStorage.setItem(this.ACCESS, access);
    localStorage.setItem(this.REFRESH, refresh);
  }

  setAccess(access: string): void {
    localStorage.setItem(this.ACCESS, access);
  }

  setRefresh(refresh: string): void {
    localStorage.setItem(this.REFRESH, refresh);
  }

  clearAccess(): void {
    localStorage.removeItem(this.ACCESS);
  }

  setAuthHack(): void {
    localStorage.setItem(this.HACK, 'true');
  }

  clearAll(): void {
    localStorage.removeItem(this.ACCESS);
    localStorage.removeItem(this.REFRESH);
    localStorage.removeItem(this.HACK);
  }
}
